import { render, staticRenderFns } from "./TenantLog.vue?vue&type=template&id=5084e840&"
import script from "./TenantLog.vue?vue&type=script&lang=js&"
export * from "./TenantLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports